import { useDispatch } from "react-redux"
import { useCatalogPaletteQuery, userbotApi } from "../store"

/** Единая точка доступа к каталогу движка (кэшируется RTK Query, один запрос /catalog/palette). */
export const useCatalog = () => {
  const dispatch = useDispatch()
  const palette = useCatalogPaletteQuery()

  const data = palette.data

  const refresh = () => dispatch(userbotApi.util.invalidateTags(["Catalog"]))

  return {
    actions: data?.actions ?? [],
    nodeKinds: data?.nodeKinds ?? [],
    matchers: data?.matchers ?? [],
    conditionOps: data?.conditionOps ?? [],
    entities: data?.entities ?? [],
    llmTasks: data?.llmTasks ?? [],
    cronPresets: data?.cronPresets ?? [],
    limits: data?.limits,
    isLoading: palette.isLoading,
    refresh,
  }
}
